import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Printer, FileText } from "lucide-react";

const Section = ({ title, children }) => (
  <section className="mt-6">
    <h2 className="font-heading text-lg font-bold text-white">{title}</h2>
    <div className="mt-2 text-[13px] text-zinc-400 leading-relaxed space-y-2">{children}</div>
  </section>
);

export default function Terms() {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100">
      <div className="no-print border-b border-zinc-800 flex items-center justify-between px-6 py-3" style={{ paddingTop: "max(0.75rem, env(safe-area-inset-top))" }}>
        <Link to="/login" className="flex items-center gap-2 text-sm text-zinc-400 hover:text-white"><ArrowLeft className="h-4 w-4" /> Back</Link>
        <button onClick={() => window.print()} className="flex items-center gap-2 text-sm font-medium px-4 py-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white"><Printer className="h-4 w-4" /> Print / PDF</button>
      </div>
      <div className="max-w-3xl mx-auto p-6 sm:p-10" data-testid="terms-page">
        <div className="flex items-center gap-2 text-blue-400"><FileText className="h-5 w-5" /><span className="text-[11px] uppercase tracking-widest font-bold">UC Engineer Pro</span></div>
        <h1 className="font-heading text-4xl font-extrabold text-white mt-2">Terms of Service</h1>
        <p className="text-[12px] text-zinc-500 mt-2">Last updated: June 2026. This is a general template — review with your legal counsel before relying on it.</p>

        <Section title="Acceptance">
          <p>By creating an account or using UC Engineer Pro, you agree to these Terms. If you use the service on behalf of an organization, you represent that you are authorized to bind it.</p>
        </Section>
        <Section title="The service">
          <p>UC Engineer Pro provides tooling and runbooks to plan and track Cisco UC migrations and CUCM 15 upgrades. Compatibility guidance and runbook content are advisory — you are responsible for validating changes against Cisco documentation and your own environment before production cutover.</p>
        </Section>
        <Section title="Accounts & workspaces">
          <p>You are responsible for maintaining the confidentiality of your credentials and for all activity in your workspace. Workspace owners control team membership and access.</p>
        </Section>
        <Section title="Subscriptions & billing">
          <p>Paid plans are billed on a recurring basis (monthly or annual) via Stripe and start immediately — there is no free trial. The Free tier is a troubleshooting-first workspace limited to 2 sites with read-only migration previews; the full production migration and estate workflow requires a paid Pro subscription. Fees are non-refundable except where required by law.</p>
        </Section>
        <Section title="Acceptable use">
          <p>Do not misuse the service, attempt to breach security, or use it unlawfully. Access is prohibited from restricted jurisdictions and by sanctioned parties.</p>
        </Section>
        <Section title="Disclaimer & limitation of liability">
          <p>The service is provided "as is" without warranties of any kind. To the maximum extent permitted by law, we are not liable for indirect or consequential damages, or for outcomes of migrations or upgrades performed using the tool.</p>
        </Section>
        <Section title="Changes">
          <p>We may update these Terms from time to time. Continued use after changes constitutes acceptance.</p>
        </Section>
        <Section title="Contact">
          <p>Questions? Contact your workspace administrator or the account owner of record.</p>
        </Section>
        <p className="mt-8 text-[12px] text-zinc-600">See also our <Link to="/privacy" className="text-blue-400 hover:text-blue-300 underline">Privacy Policy</Link>.</p>
      </div>
    </div>
  );
}
